import { createClient } from "@supabase/supabase-js";

const supabaseUrl = "https://dxhttgtsatqzwmyprrih.supabase.co";
const supabaseAnonKey =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImR4aHR0Z3RzYXRxendteXBycmloIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjkzMjU5MzcsImV4cCI6MjA4NDkwMTkzN30.-SbfBFAXkDicwUtHFEL9vtk1QGi2o2uOWHmtQ8aGcpQ";

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
